import { render, staticRenderFns } from "./EconomicActivity.vue?vue&type=template&id=68556ce5&"
import script from "./EconomicActivity.vue?vue&type=script&lang=js&"
export * from "./EconomicActivity.vue?vue&type=script&lang=js&"
import style0 from "./EconomicActivity.vue?vue&type=style&index=0&id=68556ce5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports